export const VAT_ID_CHECK_CONFIG = {
  name: 'vatNumber',
  label: 'REGULAR.FIELDS.VAT_NUMBER_FOR_TIER_TWO_SIGNUP.LABEL',
  placeholder: '12345678910',
  submitText: 'REGULAR.CONTINUE',
  noSpaces: true,
  hasRequiredMark: true,
};

export const VAT_ID_CHECK_CONFIG_ITALY = {
  ...VAT_ID_CHECK_CONFIG,
  placeholder: '12345678910',
};

export const VAT_ID_CHECK_CONFIG_PORTUGAL = {
  ...VAT_ID_CHECK_CONFIG,
  placeholder: '123456789',
};

export const VAT_ID_CHECK_CONFIG_NETHERLANDS = {
  ...VAT_ID_CHECK_CONFIG,
  name: 'kvkNumber',
  placeholder: '12345678',
  label: 'REGULAR.FIELDS.KVK_NUMBER_FOR_TIER_TWO_SIGNUP.LABEL',
};

export const VAT_ID_CHECK_CONFIG_FRANCE = {
  ...VAT_ID_CHECK_CONFIG,
  name: 'sirenNumber',
  placeholder: '123456789',
  label: 'REGULAR.FIELDS.SIREN_NUMBER_FOR_TIER_TWO_SIGNUP.LABEL',
};

export const VAT_ID_VALIDATION_CHECK_REMARKS = {
  invalidVatId: 'invalid vat',
  postalMismatch: 'postal code mismatch',
};

export const VAT_ID_VALIDATION_GA_EVENT_LABELS = {
  [VAT_ID_VALIDATION_CHECK_REMARKS.invalidVatId]: '{vatNumber - not found in VIES}',
  [VAT_ID_VALIDATION_CHECK_REMARKS.postalMismatch]: '{vatNumber - Zip Code does not match KvK}',
};
